import { TextInput, Tile } from '@Components/common';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './Documents.module.scss';
import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { FileUpload } from '@Components/common/FileUpload/FileUpload';
import { NumericFormat } from 'react-number-format';

export const Documents = () => {
  const { t } = useTranslation('account');
  const { errors, control } = useFormContext();

  return (
    <Tile
      title={{
        title: t('tabs.documents.add_documents'),
        subtitle: (
          <Trans
            ns="account"
            i18nKey="tabs.documents.add_documents_subtitle"
            components={[<a href="https://actionfunder.org/help-centre" />]}
          />
        ),
      }}
      className={classNames(styles.documentsTile)}
    >
      <div className={styles.documentsContainer}>
        <FileUpload
          fieldName={'governing_documents'}
          config={{
            maxFiles: 1,
            multiple: false,
            maxSize: 15 * 1024 * 1024, // 15MB
          }}
          title={t('tabs.documents.governing_document_title')}
          subTitle={t('tabs.documents.governing_document_subtitle')}
          header={t('tabs.documents.governing_document_upload')}
          required={false}
        />
        <FileUpload
          fieldName={'annual_accounts'}
          config={{
            maxSize: 15 * 1024 * 1024, // 15MB
          }}
          title={t('tabs.documents.annual_accounts_title')}
          subTitle={t('tabs.documents.annual_accounts_subtitle')}
          header={t('tabs.documents.annual_accounts_upload')}
          required={false}
        />

        <Controller
          name="annual_income"
          control={control}
          render={({ ref, onChange, value }) => (
            <NumericFormat
              customInput={TextInput}
              label={t('tabs.documents.annual_income')}
              placeholder={t('tabs.documents.annual_income_subtitle')}
              name="annual_income"
              type="text"
              inputRef={ref}
              error={!!errors.annual_income}
              helperText={errors.annual_income?.message}
              className={styles.shortField}
              thousandSeparator={','}
              prefix={'£'}
              valueIsNumericString
              value={value}
              onChange={onChange}
            />
          )}
        />
      </div>
    </Tile>
  );
};
